import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectTitle } from "../../actions";
import { IoCheckmarkOutline } from "react-icons/io5";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

interface Network {
  id: string;
  title: string;
  network: string;
  image: string;
}

interface RootState {
  selectedTitle: any;
  networks: Network[];
}

const SecondDropdown = () => {
  const networks = useSelector((state: RootState) => state.networks);
  const selectedTitle = useSelector((state: RootState) => state.selectedTitle);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  // Check local storage for the selected title and set it as the initial value
  useEffect(() => {
    const storedTitle = localStorage.getItem("selectedTitle");
    if (storedTitle) {
      dispatch(selectTitle(storedTitle));
    }
  }, [dispatch]);

  const handleTitleChange = (title: string) => {
    localStorage.setItem("selectedTitle", title);
    dispatch(selectTitle(title));
  };

  // close the dropdown when clicking outside
  useEffect(() => {
    const closeDropdown = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", closeDropdown);

    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        className="flex justify-center items-center gap-4 p-3 rounded-xl cursor-pointer"
        onClick={toggleDropdown}
      >
        {selectedTitle ? (
          <div className="flex items-center gap-2 text-white">
            <div className="border border-transparent_200 w-10 h-10 flex justify-center items-center rounded-xl ">
              <img
                src={
                  networks.find((network) => network.title === selectedTitle)
                    ?.image
                }
                alt={`Logo of ${selectedTitle}`}
                className="w-4 h-4"
              />
            </div>
            <span>{selectedTitle}</span>
          </div>
        ) : (
          networks.length > 0 && (
            <div className="flex items-center gap-2 text-white">
              <div className="border border-transparent_200 w-10 h-10 flex justify-center items-center rounded-xl ">
                <img
                  src={networks[0].image}
                  alt={`Logo of ${networks[0].image}`}
                  className="w-4 h-4"
                />
              </div>
              <span>{networks[0].title}</span>
            </div>
          )
        )}
        {isDropdownOpen ? (
          <IoIosArrowUp className="text-white" />
        ) : (
          <IoIosArrowDown className="text-white" />
        )}
      </div>

      {isDropdownOpen && (
        <ul className="absolute z-10 mt-2 w-64 -right-5 md:right-0 p-2 text-white rounded-xl shadow-navbarShadow bg-dropdown_bg border border-dropdown_border">
          {networks.map((network) => (
            <li
              key={network.id}
              onClick={() => {
                handleTitleChange(network.title);
                toggleDropdown();
              }}
              className={`rounded-xl p-2 transition duration-200 hover:bg-transparent_700 cursor-pointer flex justify-between gap-2 items-center ${
                selectedTitle === network.title ? "" : ""
              }`}
            >
              <div className="flex gap-3 items-center">
                <img
                  src={network.image}
                  alt={`Logo of ${network.title}`}
                  className="w-4 h-4"
                />
                <span className="text-base font-sm">{network.title}</span>
              </div>
              {selectedTitle === network.title && (
                <IoCheckmarkOutline className="w-4 h-4 text-icon_color" />
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SecondDropdown;
